/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNitroStore } from "../../store/Store";

import { useIsMobile } from "../../hooks/useIsMobile";
import IOSSwitch from "../../components/IOSSwitch";

const HidePinsPopup = () => {
  const isMobile = useIsMobile(768);

  const [open, setOpen] = useState(false);

  const [
    currentFilters,
    product,
    mode,
    partyTypes,
    selectedLocation,
    selectingPinLocation,
    showInsightsPanel,
    storageFacilityCityWarning,
    storageFacilityStateWarning,
    showAddLocationPanel,
    hidePins,
    setHidePins,
  ] = useNitroStore((state) => [
    state.currentFilters,
    state.product,
    state.mode,
    state.partyTypes,
    state.selectedLocation,
    state.selectingPinLocation,
    state.showInsightsPanel,
    state.storageFacilityCityWarning,
    state.storageFacilityStateWarning,
    state.showAddLocationPanel,
    state.hidePins,
    state.setHidePins,
  ]);

  // TODO: is any of this even used since we determine showing the panel in the top level map component?
  useEffect(() => {
    const { city, party } = currentFilters;
    if (!city && !party) {
      return setOpen(false);
    }

    if (showAddLocationPanel) return setOpen(false);

    if (
      !party &&
      (partyTypes.length === 3 || partyTypes.length === 0) &&
      !product &&
      !mode
    ) {
      return setOpen(false);
    }

    return setOpen(true);
  }, [
    setOpen,
    currentFilters,
    product,
    mode,
    partyTypes,
    selectedLocation,
    showAddLocationPanel,
  ]);

  // Reset hide pins when filters change to avoid confusion of pins disappearing without user interaction. We can consider persisting this setting in the future if users prefer it.
  useEffect(() => {
    if (hidePins) {
      setHidePins(false);
    }
  }, [currentFilters]);

  if (selectingPinLocation || showInsightsPanel) {
    return null;
  }

  if (storageFacilityCityWarning || storageFacilityStateWarning) {
    return null;
  }

  if (!open) {
    return null;
  }

  if (isMobile) {
    return null;
  }

  return (
    <div
      id="ExpandSearch"
      style={{
        position: "fixed",
        bottom: 20,
        left: "calc((100vw - 400px - 365px) / 2 + 500px)",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          border: "1px solid #CAD5E2",
          borderRadius: 20,
          backgroundColor: "white",
          color: "black",
          display: "flex",
          width: 290,
          height: 57,
          boxShadow:
            "0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px 0px rgba(0, 0, 0, 0.3)",
        }}
      >
        <div
          style={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            gap: 6,
            padding: 15,
            paddingTop: 9,
            paddingRight: 0,
          }}
        >
          <div style={{ fontSize: 14, fontWeight: 500 }}>Map Pins</div>

          <div
            style={{
              flexGrow: 1,
              display: "flex",
              alignItems: "center",
              fontSize: 13,
              fontWeight: 500,
            }}
          >
            Hide pins without {product}
          </div>
        </div>

        <div
          style={{
            width: 70,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <IOSSwitch
            sx={{
              "& .MuiSwitch-switchBase": {
                "&.Mui-checked": {
                  "& + .MuiSwitch-track": {
                    backgroundColor: "#1D4ED8",
                  },
                },
              },
            }}
            checked={hidePins}
            onChange={(e) => {
              setHidePins(e.target.checked);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default HidePinsPopup;
